import React from "react";

const Advertise = () => {
  return <div className=" my-12"></div>;
};

export default Advertise;
